<template>
    <el-dialog :title="userId ? '编辑授权' : '新增授权'" :visible.sync="authorizedOperatorVisible" width="600px" :before-close="handleDialogClose" :close-on-click-modal="false"
        class="custom-form-dialog custom-authorized-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="授权人员" prop="type">
                <template slot="label">
                    <p>授权人员<span class="label-tip-txt">（被授权的人员拥有下方配置的全部权限）</span></p>
                </template>
                <div class="select-author-btn" @click="handleClickSelectAuthor">
                    <div><span>{{ authorizedPersonnelData.text || "点击授权" }}</span></div>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </el-form-item>
            <el-form-item label="权限范围" prop="uid" class="label-bold custom-form-item-content">
                <ul class="author-list">
                    <li class="author-list-item">
                        <div class="author-list-header flex">
                            <div>
                                <p class="text-bold">人员组织</p>
                                <p>可查看、管理部门和人员的入转调离</p>
                            </div>
                            <el-switch v-model="formData.switch1">
                            </el-switch>
                        </div>
                        <div class="author-list-content">
                            <div class="content-tag-item">
                                <p class="text-bold">常规权限</p>
                                <div class="flex">
                                    <div class="check-box">

                                    </div>
                                    <div>
                                        <p>查看权限</p>
                                        <p>可以查看部门人员信息</p>
                                    </div>

                                </div>
                                <div class="flex">
                                    <div class="check-box">
                                        <el-checkbox v-model="formData.check2"></el-checkbox>
                                    </div>
                                    <div>
                                        <p>管理权限</p>
                                        <p>可对部门和人员进行新增、编辑、变更、导出、删除部门的操作</p>
                                    </div>
                                </div>
                            </div>
                            <div class="content-tag-item">
                                <p class="text-bold">敏感权限</p>
                                <div class="flex">
                                    <div class="check-box">
                                        <el-checkbox v-model="formData.check1"></el-checkbox>
                                    </div>
                                    <div>
                                        <p>后台设置</p>
                                        <p>设置字段、人员标签、名片设置</p>
                                    </div>

                                </div>
                                <div class="flex">
                                    <div class="check-box">
                                        <el-checkbox v-model="formData.check2"></el-checkbox>
                                    </div>
                                    <div>
                                        <p>办理离职</p>
                                        <p>可对人员进行办理离职、确认离职、取消离职的操作</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="author-list-item">
                        <div class="author-list-header flex">
                            <div>
                                <p class="text-bold">离职管理</p>
                                <p>可查看、编辑离职人员，办理离职</p>
                            </div>
                            <el-switch v-model="formData.switch1">
                            </el-switch>
                        </div>
                        <div class="author-list-content">
                            <div class="content-tag-item">
                                <p class="text-bold">常规权限</p>
                                <div class="flex">
                                    <div class="check-box">
                                        <el-checkbox v-model="formData.check1"></el-checkbox>
                                    </div>
                                    <div>
                                        <p>查看权限</p>
                                        <p>可以查看部门人员信息</p>
                                    </div>

                                </div>
                                <div class="flex">
                                    <div class="check-box">
                                        <el-checkbox v-model="formData.check2"></el-checkbox>
                                    </div>
                                    <div>
                                        <p>管理权限</p>
                                        <p>可对部门和人员进行新增、编辑、变更、导出、删除部门的操作</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">确认</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: "authorizedOperatorVisible",
    props: {
        authorizedOperatorVisible: {
            type: Boolean,
            default: false
        },
        authorizedPersonnelData: {
            type: Object,
            default: {
                text: ""
            }
        }, // 授权人员数据
        userId: {}
    },
    data() {
        return {
            formData: {
                user_ids: [],
                check1: false,
                check2: false
            },
            formRules: {

            },
            userList: []

        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:authorizedOperatorVisible", false)
        },
        handleClickSelectAuthor() {
            this.$emit("selectAuthor")
        },
        handleDialogConfirm() {
        },

    }
}
</script>
<style lang="scss">
.custom-authorized-dialog {
    .el-dialog__body {
        max-height: 760px;
        overflow-y: scroll;
    }

    .custom-form-item-content {
        .el-form-item__content {
            height: auto;
            line-height: normal;
        }
    }

    .select-author-btn {
        width: 100%;
        height: 32px;
        padding: 12px;
        opacity: 1;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D9D9D9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;

        .el-icon-arrow-down {
            color: #666666;
        }

        &:active {
            border-color: #409EFF;
        }
    }

    .label-tip-txt {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}

.author-list {
    .text-bold {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .author-list-item {
        border-radius: 8px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        margin-bottom: 12px;

        .author-list-header {
            padding: 0 16px;
            height: 74px;
            align-items: center;
            justify-content: space-between;
            position: relative;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);

            &::after {
                content: "";
                position: absolute;
                left: 16px;
                right: 0;
                bottom: 0;
                height: 1px;
                background: #E8E8E8;
            }
        }

        .author-list-content {
            padding: 16px 16px 0;
        }

        .content-tag-item {
            margin-bottom: 16px;

            &>div {
                margin-top: 12px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);

                .check-box {
                    width: 24px;
                    flex-shrink: 0;
                }

                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
